export default __webpack_public_path__ + "static/media/warning--children--g3.7d28f751.png";